// == Import npm
import React, { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

// == import i18n
import { useTranslation } from "react-i18next";

// == Import SCSS
import "./searchByLostBadge.less";

// == Import assets
import { ReactComponent as Character } from "../../assets/illustrations/character-2.svg";

// == import component
import SearchBar from "components/SearchBar/SearchBar";

const SearchByLostBadge = () => {
  const [t] = useTranslation();

  const [display, setDisplay] = useState(true);

  const { residentList } = useSelector(state => state.visits);

  const type = "resident";
  const searchText = t("SearchByFirstOrLastNameOfEmployee");

  const cssClassDisplay = classNames("searchByLostBadge", {
    "searchByLostBadge--display": !display,
  });

  const closeBubble = () => {
    setDisplay(true);
  };

  return (
    <div className={cssClassDisplay} onClick={closeBubble} style={{ height: window.innerHeight }}>
      <p className="searchByLostBadge__texte">
        <Character className="searchByLostBadge__texte__img" />
        {t("WhatIsYourNamePlease")} ?
      </p>

      <SearchBar
        searchResult={residentList}
        type={type}
        searchText={searchText}
        setDisplay={setDisplay}
        badgeLost={true}
      />
    </div>
  );
};

export default SearchByLostBadge;
